import {
  Heading,
  SpacingToken,
  Text,
} from '@livechat/design-system-react-components'
import React, { useMemo } from 'react'
import isEmpty from 'lodash/isEmpty'
import { Edit, VisibilityOn } from '@livechat/design-system-icons'
import { css } from '@emotion/react'

import type { ApplicationScope } from '@/apis/accounts/interfaces'
import { getClientFeatures, getScopeGroups } from '@/utils/auth/accounts'

import { ScopesAccordion } from './ScopesAccordion'

const scopesHeadingCss = css`
  margin: 0;
`

const descriptionCss = css`
  margin: var(${SpacingToken.Spacing1}) 0 var(${SpacingToken.Spacing3});
`

const accordionsWrapperCss = css`
  display: flex;
  flex-direction: column;
  row-gap: var(${SpacingToken.Spacing3});
`

interface Props {
  name: string
  scopes: ApplicationScope[]
}

export const Scopes = ({ name, scopes }: Props) => {
  const clientFeatures = useMemo(
    () => getClientFeatures(scopes.map(({ scope }) => scope)),
    [scopes]
  )

  const readOnlyScopes = useMemo(
    () => getScopeGroups(clientFeatures, true),
    [clientFeatures]
  )
  const readAndWriteScopes = useMemo(
    () => getScopeGroups(clientFeatures, false),
    [clientFeatures]
  )

  if (isEmpty(clientFeatures)) {
    return null
  }

  return (
    <div>
      <Heading size="xs" css={scopesHeadingCss} data-test="scopes-header">
        Scopes
      </Heading>
      <Text css={descriptionCss} data-test="scopes-text">
        Installing {name} will give the developer access to:
      </Text>

      <div css={accordionsWrapperCss}>
        <ScopesAccordion
          category="View"
          scopeGroups={readOnlyScopes}
          icon={VisibilityOn}
        />
        <ScopesAccordion
          category="Edit"
          scopeGroups={readAndWriteScopes}
          icon={Edit}
        />
      </div>
    </div>
  )
}
